import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import DeleteDataPopUp from './DeleteDataPopUp';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import axiosInterceptor from '../../services/axiosInterceptor';

const AccountSettings = ({ username, logout }) => {
    const [giftCardExists, setGiftCardExists] = useState(false);

    useEffect(() => {
        checkGiftCards();
    });

    let checkGiftCards = async () => {
        const gift_card_data = await axiosInterceptor().post(
            'twitter/checkGiftCards',
            { username: username }
        );

        if (gift_card_data?.data?.check == 'Giftcards exists') {
            setGiftCardExists(true);
        } else {
            setGiftCardExists(false);
        }
    };

    return (
        <Container className="text-left p-4">
            <h4 className="my-4" style={{ textAlign: 'center' }}>
                <FormattedMessage
                    id="Account.title"
                    defaultMessage="Account Settings"
                />
            </h4>

            <Row className="align-items-center">
                <Col sm={8}>
                    <p className="h5">
                        <FormattedMessage
                            id="Account.deleteAccTitle"
                            defaultMessage="Delete My Account"
                        />
                    </p>
                    <p className="text-muted">
                        <FormattedMessage
                            id="Account.deleteAccDescription"
                            defaultMessage="By deleting your account, all of your surveys and crawled twitter
            data will be deleted. Further, you will be ineligible for future
            INCAS surveys."
                        />
                    </p>
                </Col>

                <Col>
                    {!giftCardExists && (
                        <DeleteDataPopUp
                            username={username}
                            logout={logout}
                            type="with-credentials"
                        />
                    )}
                    {giftCardExists && (
                        <p>
                            <FormattedMessage
                                id="New2.deleteAfterGifted"
                                defaultMessage="After having received the gift cards, you can
                            request your data to be removed by emailing"
                            />

                            <a
                                style={{ textDecoration: 'none' }}
                                href="mailto: support@yourmorals.org"
                                target="_blank"
                            >
                                support@yourmorals.org
                            </a>
                        </p>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default AccountSettings;
